import React, { useState, useEffect } from "react";
import {
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  User,
} from "@nextui-org/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaUser } from "react-icons/fa6";
import { removeAuth } from "../store/slices/authSlice";
import { toast } from "react-toastify";
import { refreshIfNeeded } from "../store/actions/refreshIfNeeded";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "@nextui-org/react";
import axios from "axios";
const UserMenu = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let role = localStorage.getItem("role");
  let user_role = JSON.parse(localStorage.getItem("user_details"))?.role;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  const { user } = useSelector((state) => state.auth);
  const handleConfirmDelete = async () => {
    if (busy) return;
    setIsDeleteModalOpen(false); // close modal first (avoids setState after navigate)
    await blockUser(); // this already handles busy + navigate
  };

  const [img, setImg] = useState("");
  const [busy, setBusy] = useState(false);
  const authHeaders = () => ({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      "Content-Type": "application/json",
    },
  });
  const ensureAuth = async () => {
    await dispatch(refreshIfNeeded());
    return authHeaders();
  };

  const blockUser = async () => {
    setBusy(true);
    try {
      const headers = await ensureAuth();
      await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/users/blockandunblock?action=BLOCK`,
        {},
        headers
      );
      toast.success("✅ Your account is deleted successfully");
      localStorage.clear();
      dispatch(removeAuth());
      navigate("/login");
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "❌ Failed to delete user";
      toast.error(msg);
      if (error?.response?.status === 401) {
        localStorage.clear();
        dispatch(removeAuth());
        navigate("/login");
      }
    } finally {
      setBusy(false);
    }
  };


useEffect(() => {
  if (user?.profile_id) {
     setImg(user?.profile_id || undefined);
  } else {
    setImg(null);
  }
}, [user?.profile_id]);




  const handleLogout = () => {
    localStorage.clear();
    dispatch(removeAuth());
    navigate("/login");
  };
  const userProfile = () => {
    navigate("/user-profile");
  };

  const helpFeedback = () => {
    navigate("/help&feedback");
  };

  const showDisputes = () => {
    navigate("/support");
  };

  const switchAccount = async () => {
    setBusy(true);
    try {
      const data =
        role === "SUPPLIER" ? { role: "CUSTOMER" } : { role: "SUPPLIER" };
      const headers = await ensureAuth();
      const res = await axios.put(
        `${process.env.REACT_APP_SERVER_URL}/users/togglemode`,
        data,
        headers
      );
      if (res?.data?.role) localStorage.setItem("role", res.data.role);
      if (res?.data?.accessToken)
        localStorage.setItem("accessToken", res.data.accessToken);
      window.location.reload();
    } catch (error) {
      const msg =
        error?.response?.data?.message ||
        error?.message ||
        "Failed to switch account";
      toast.error(msg);
      if (error?.response?.status === 401) {
        localStorage.clear();
        dispatch(removeAuth());
        navigate("/login");
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <Dropdown placement="bottom-start">
        <DropdownTrigger className="sm:[&>*:last-child]:inline-flex [&>*:last-child]:hidden">
          <User
            as="button"
              key={img || "no-img"}
              avatarProps={{
              isBordered: false,
              src: img, // undefined triggers fallback correctly
              showFallback: true,
              fallback: <FaUser fontSize={18} color="gray" />,
            }}
            className="transition-transform font-semibold"
            description={role}
            name={
              user?.first_name || user?.last_name
                ? user?.first_name + " " + user?.last_name
                : ""
            }
          />
        </DropdownTrigger>
        <DropdownMenu aria-label="User Actions" variant="flat">
          <DropdownItem key="profile" className="pointer-events-none">
            <p className="text-xs">Signed in as</p>
            <p className="font-bold">{user?.role}</p>
          </DropdownItem>

          {user?.role === "SUPPLIER" ? (
            <DropdownItem
              onPress={switchAccount}
              onTouchStart={switchAccount}
              isDisabled={busy}
            >
              Switch as {role === "SUPPLIER" ? "Customer" : "Supplier"}
            </DropdownItem>
          ) : null}
          <DropdownItem
            key="settings"
            onClick={userProfile}
            onTouchStart={userProfile}
          >
            My Profile
          </DropdownItem>
          <DropdownItem
            key="help_and_feedback"
            onClick={helpFeedback}
            onTouchStart={helpFeedback}
          >
            Help & Feedback
          </DropdownItem>
          {user_role !== "ADMIN" && (
            <DropdownItem
              key="support"
              onClick={showDisputes}
              onTouchStart={showDisputes}
            >
              Support
            </DropdownItem>
          )}
          {/* {(user?.role === "SUPPLIER" || user?.role === "CUSTOMER") &&
            (user?.status === "BLOCKED_BY_USER" ? (
              <DropdownItem
                key="blocked"
                color="danger"
                isDisabled
                className="text-gray-400"
              >
                DELETED
              </DropdownItem>
            ) : (
              <DropdownItem
                key="block"
                color="danger"
                onClick={() => setIsDeleteModalOpen(true)}
                onTouchStart={() => setIsDeleteModalOpen(true)}
                isDisabled={busy}
              >
                DELETE
              </DropdownItem>
            ))} */}
          <DropdownItem
            key="logout"
            color="danger"
            onClick={handleLogout}
            onTouchStart={handleLogout}
            isDisabled={busy}
          >
            Log Out
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
      <Modal
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
        backdrop="blur"
      >
        <ModalContent>
          <ModalHeader className="text-danger font-bold">
            Confirm Deletion
          </ModalHeader>
          <ModalBody>
            <p>⚠️ Are you sure you want to delete this account?</p>
            <p>This action cannot be undone.</p>
          </ModalBody>
          <ModalFooter>
            <Button
              variant="light"
              onPress={() => setIsDeleteModalOpen(false)}
              isDisabled={busy}
            >
              {" "}
              Cancel
            </Button>
            <Button
              color="danger"
              isDisabled={busy}
              isLoading={busy}
              onPress={handleConfirmDelete}
            >
              Yes, Delete
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default UserMenu;
